<!-- #29 -->
<template>
  <v-col class="mx-4">
    <div class="d-flex">
      <div
        class="text-h6 py-0 my-0 pl-0"
        style="color: #23468c; font-weight: 500"
      >
        Document
      </div>
      <v-spacer></v-spacer>
    </div>
    <v-divider class="mt-1 mb-4"></v-divider>

    <v-card class="mt-2">
      <v-card-title>
        <span class="body-1 font-weight-bold"
          >{{ $route.params.id == 0 ? "Add" : "Edit" }}

          <i class="caption red--text ml-4"> * required field</i>
        </span>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-form ref="form">
          <v-row>
            <v-col cols="12" sm="6" class="pb-0">
              <v-text-field
                label="Doc Title"
                v-model="doc_title"
                :rules="[(v) => !!v || 'Doc Title is required.']"
                class="required"
                maxlength="100"
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" class="pb-0">
              <v-text-field
                label="Doc Description"
                v-model="doc_desc"
                maxlength="100"
                :rules="[(v) => !!v || 'Doc Description is required.']"
                class="required"
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" class="pb-0">
              <v-autocomplete
                v-model="doc_type"
                :items="docsType"
                hide-no-data
                item-text="name"
                item-value="id"
                label="Select Doc Type"
                class="required"
                placeholder="Start typing to Search"
                outlined
                :rules="[(v) => !!v || 'Doc Type is required.']"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6" class="pb-0">
              <v-select
                v-model="user_category"
                label="User Category"
                :rules="[(v) => !!v || 'User Category is required.']"
                class="required"
                item-text="value"
                item-value="id"
                :items="userTypes"
                outlined
                @change="getserviceslist()"
              ></v-select>
            </v-col>
            <v-col
              cols="12"
              md="6"
              sm="6"
              class="pb-0"
              v-if="user_category === 1"
            >
              <v-select
                v-model="client_service_type"
                label="Service Type"
                :items="services"
                item-text="name"
                outlined
                item-value="id"
                :rules="[(v) => !!v || 'Service Type is required']"
                @change="fetchClientList()"
                class="required"
              ></v-select>
            </v-col>
            <v-col
              v-if="user_category === 1 && client_service_type"
              cols="12"
              sm="6"
              class="pb-0"
            >
              <v-autocomplete
                v-model="client_id"
                :items="clients"
                :loading="clientLoader"
                hide-no-data
                item-text="name"
                item-value="id"
                label="Select Client"
                placeholder="Start typing to Search"
                @change="fetchClientList()"
                outlined
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6" class="pb-0">
              <v-autocomplete
                v-model="status"
                :items="statuses"
                hide-no-data
                item-text="text"
                item-value="value"
                class="required"
                label="Select Status"
                :rules="[(v) => !!v || 'Status is required.']"
                outlined
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6" class="pb-0" v-if="$route.params.id > 0">
              <v-file-input
                v-model="data_file"
                label="Upload files"
                multiple
                outlined
                show-size
                prepend-icon=""
                prepend-inner-icon="mdi-paperclip"
                accept=".pdf"
              ></v-file-input>
            </v-col>
            <v-col cols="12" sm="6" class="pb-0" v-else>
              <v-file-input
                v-model="data_file"
                label="Upload files"
                multiple
                :rules="[(v) => (v && v.length > 0) || 'File is required.']"
                outlined
                show-size
                class="required"
                prepend-icon=""
                clearable
                prepend-inner-icon="mdi-paperclip"
                accept=".pdf"
                @click="data_file = null"
              ></v-file-input>
            </v-col>
          </v-row>

          <v-btn
            class="mt-5"
            color="primary"
            @click="save()"
            :loading="saveLoader"
            dark
            v-if="$route.params.id > 0"
          >
            Update
          </v-btn>
          <v-btn
            class="mt-5"
            color="primary"
            @click="save()"
            :loading="saveLoader"
            dark
            v-else
          >
            save
          </v-btn>
          <v-btn
            class="mt-5 ml-3"
            color="white"
            @click="$router.push('/doc-list')"
          >
            Cancel
          </v-btn>
        </v-form>
      </v-card-text>
    </v-card>

    <v-card class="mt-2" v-if="$route.params.id > 0 && files.length">
      <v-card-title>
        <span class="body-1 font-weight-bold">Delete Uploaded Files </span>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-form>
          <v-card>
            <v-simple-table dense>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">File Name</th>
                    <th class="text-left">Delete</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(file, index) in files" :key="index">
                    <td>{{ file }}</td>
                    <td>
                      <v-btn
                        icon
                        color="red"
                        @click="openUnlinkedPopup(file, index)"
                      >
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>
        </v-form>
      </v-card-text>
    </v-card>
    <v-dialog v-model="unlinkedDialog" max-width="290" persistent>
      <v-card>
        <v-card-title class="headline">Delete File</v-card-title>
        <v-divider class="mb-2"></v-divider>
        <v-card-text> Are you sure you want to delete this file? </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="white" small @click="unlinkedDialog = false">
            Cancel
          </v-btn>

          <v-btn color="primary" small @click="unlinked()"> Delete </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-col>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { serviceTypes } from "@/config/data";
export default {
  computed: {
    ...mapGetters(["userTypes"]),
    allServiceTypes() {
      return Object.keys(serviceTypes).map((i) => {
        return {
          text: serviceTypes[i],
          value: i,
        };
      });
    },
  },
  data() {
    return {
      filetoUnlinked: "",
      unlinkedDialog: false,
      docData: {},
      allGroups: [],
      saveLoader: false,
      loader: false,
      clientLoader: false,
      clients: [],
      sellerLoader: false,
      sellers: [],
      statuses: [
        { text: "Active", value: "True" },
        { text: "Inactive", value: "False" },
      ],
      docsType: [
        "Last Mile SOP",
        "Prohibited and Restricted Item List",
        "Customs De Miniums",
        "Customer Rate Card",
        "Customs Related Charges",
      ],
      services: [],
      doc_name: "",
      doc_title: "",
      doc_desc: "",
      doc_type: "",
      user_category: "",
      client_service_type: "",
      client_id: "",
      status: "",
      data_file: [],
      files: [],
    };
  },
  created() {
    this.getUserTypes();
    if (this.$route.params.id > 0) {
      this.callApi(this.$route.params.id);
    }
  },
  methods: {
    ...mapActions([
      "createMember",
      "updateMember",
      "getGroups",
      "fetchClient",
      "getTypeClients",
      "snackBar",
      "addLogisticDoc",
      "getUserTypes",
      "getDocumentRecord",
      "updateLogisticDoc",
      "unlinkedFile",
    ]),

    callApi(id) {
      this.getDocumentRecord(id).then((res) => {
        this.doc_title = res.data.records[0].doc_title;
        this.doc_desc = res.data.records[0].doc_desc;
        this.doc_type = res.data.records[0].doc_type;
        this.user_category = res.data.records[0].user_category;
        this.client_service_type = res.data.records[0].client_service_type;
        this.client_id = res.data.records[0].rsa_client;

        if (res.data.records[0].user_category == 1) {
          this.getserviceslist();
          this.fetchClientList();
        }
        this.status =
          res.data.records[0].doc_status === true ? "True" : "False";

        if (res.data.records[0].doc_file !== null)
          this.files = res.data.records[0].doc_file.split(",");
      });
    },
    getserviceslist() {
      if (this.user_category == 1) {
        this.getTypeClients().then((res) => {
          this.services = res.data;
        });
      } else {
        this.client_service_type = "";
        this.client_id = "";
      }
    },
    fetchClientList() {
      if (!this.user_category === 1) return;
      this.clientLoader = true;

      this.fetchClient({
        fields: "id,name",
        pagination: 0,
        service: this.client_service_type,
      })
        .then((res) => {
          this.clientLoader = false;
          this.clients = res.data;
        })
        .catch(() => {
          this.clientLoader = false;
        });
    },
    openUnlinkedPopup(file, index) {
      this.unlinkedDialog = true;
      this.filetoUnlinked = file;
      this.index = index;
    },
    unlinked() {
      let payload = {
        file_name: this.filetoUnlinked,
      };
      let data = {
        data: payload,
        id: this.$route.params.id,
      };
      this.unlinkedFile(data).then((res) => {
        this.snackBar({ message: res.data.message, color: "success" });
        this.files.splice(this.index, 1);
        this.unlinkedDialog = false;
      });
    },
    save() {
      if (!this.$refs.form.validate()) {
        return;
      }
      const payload = new FormData();
      for (let i = 0; i < this.data_file.length; i++) {
        payload.append("data_file", this.data_file[i], this.data_file[i].name);
      }

      payload.append("doc_title", this.doc_title);
      payload.append("doc_desc", this.doc_desc);
      payload.append("doc_status", this.status);
      payload.append("doc_type", this.doc_type);
      payload.append("user_category", this.user_category);
      if (this.client_service_type)
        payload.append("client_service_type", this.client_service_type);
      if (this.client_id) payload.append("rsa_client", this.client_id);

      this.saveLoader = true;
      if (this.$route.params.id > 0) {
        payload.append("id", this.$route.params.id);
        if (this.user_category !== 1) {
          payload.delete("rsa_client");
          payload.delete("client_service_type");
        }
        let data = {
          data: payload,
          id: this.$route.params.id,
        };
        this.updateLogisticDoc(data)
          .then((res) => {
            this.saveLoader = false;
            this.$router.replace({
              name: "ServieCenterList",
            });
            this.snackBar({
              color: "success",
              message: res.data.message,
            });
          })
          .catch(() => {
            this.saveLoader = false;
          });
      } else {
        this.addLogisticDoc(payload)
          .then((res) => {
            this.saveLoader = false;
            this.$router.replace({
              name: "ServieCenterList",
            });
            this.snackBar({
              color: "success",
              message: res.data.message,
            });
          })
          .catch(() => {
            this.saveLoader = false;
          });
      }
    },
  },
};
</script>
